<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <span style="font-weight: 600;float: left;margin-left: 30px;font-size: 16px;">批次:{{batchName}}</span>
            <el-button type="primary" icon="wl-icon-fanhui" @click="fanhui">返回</el-button>
        </header>
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="studentDisplayName" placeholder="请输入姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="idCard" placeholder="请输入证件号码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="certificateNumber" placeholder="请输入证书编号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="certificateType" placeholder="请选择证书类型" clearable @change="getItcCertificateList">
                        <el-option label="物流管理职业技能等级证书" value="物流管理职业技能等级证书"></el-option>
                        <el-option label="供应链运营职业技能等级证书" value="供应链运营职业技能等级证书"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-select v-model="searchAuditStatus" clearable placeholder="请选择审核状态" @change="getItcCertificateList">
                        <el-option label="待审核" :value="0"></el-option>
                        <el-option label="审核通过(未颁证)" :value="1"></el-option>
                        <el-option label="审核未通过" :value="2"></el-option>
                        <el-option label="审核通过(已申请纸质证书)" :value="3"></el-option>
                        <el-option label="审核通过且颁证" :value="4"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-select v-model="certificateBatchId" clearable placeholder="请选择证书批次" :disabled="batchId!=''">
                        <el-option v-for="item in batchList" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getItcCertificateList()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                    <el-button type="primary" @click="ImportDialogVisible = true">导入</el-button>
                    <!-- <el-button class="stu-add-button" type="primary" @click="openTXtDialog()">头像上传</el-button> -->
                    <el-button type="danger" icon="el-icon-delete" @click="deleteAll">删除</el-button>
                    <a class="export-button-a" style="color:#fff;margin-left:10px;" :href="exportExam">导出</a>
                    <!-- <el-button type="primary" icon="el-icon-delete" @click="DeleteAllDialogVisible = true">删除</el-button> -->
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list" ref="multipleeeeTable" @selection-change="handleSelectionChange" :row-key="getRowKeys">
                <el-table-column prop="id" type="selection" :reserve-selection="true" width="55"></el-table-column>
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="studentDisplayName" label="姓名"></el-table-column>
                <el-table-column prop="studentPinYin" label="姓名拼音"></el-table-column>
                <el-table-column prop="unitName" label="考核点"></el-table-column>
                <el-table-column prop="idType" label="证件类型"></el-table-column>
                <el-table-column prop="idCard" label="证件号码"></el-table-column>
                <el-table-column prop="certificateNumber" label="证书编号"></el-table-column>
                <el-table-column prop="certificateName" label="证书名称"></el-table-column>
                <el-table-column prop="certificateType" label="证书类型"></el-table-column>
                <el-table-column prop="certificateLevel" label="证书等级"></el-table-column>
                <el-table-column prop="certificateIssueDate" label="证书签发日期"></el-table-column>
                <el-table-column prop="certificateBatchName" label="证书批次"></el-table-column>
                <!-- <el-table-column prop="studentUrl" label="照片">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.studentUrl !=''"
                        placement="right"
                        width="400"
                        trigger="hover">
                        <img :src="scope.row.studentUrl" style="width: 400px;"/>
                        <img :src="scope.row.studentUrl" style="width: 100px;" slot="reference"/>
                        </el-popover>
                        <span v-else>暂无照片</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="dateCreated" label="创建日期"></el-table-column>
                <el-table-column prop="emailAddress" label="邮箱"></el-table-column>

                <!-- <el-table-column prop="auditStatus" label="审核状态">
                    <template slot-scope="scope">
                        <el-popover v-if="scope.row.auditOpinion !='' && scope.row.auditStatus ==2"
                            placement="right"
                            width="400"
                            trigger="hover">
                            <span style="width: 400px;">
                                审核意见:{{scope.row.auditOpinion}}
                            </span>
                            <span slot="reference">
                                <span v-if="scope.row.auditStatus == 0" style="color:#b5b531;">待审核</span>
                                <span v-else-if="scope.row.auditStatus == 1" style="color:green;">审核通过(未颁证)</span>
                                <span v-else-if="scope.row.auditStatus == 2" style="color:red;">审核未通过</span>
                                <span v-else-if="scope.row.auditStatus == 3" style="color:#b5b531;">审核通过(已申请纸质证书)</span>
                                <span v-else-if="scope.row.auditStatus == 4" style="color:green;">审核通过且颁证</span>
                               
                            </span>
                        </el-popover>
                        <span v-else>
                            <span v-if="scope.row.auditStatus == 0" style="color:#b5b531;">待审核</span>
                            <span v-else-if="scope.row.auditStatus == 1" style="color:green;">审核通过(未颁证)</span>
                            <span v-else-if="scope.row.auditStatus == 2" style="color:red;">审核未通过</span>
                            <span v-else-if="scope.row.auditStatus == 3" style="color:#b5b531;">审核通过(已申请纸质证书)</span>
                            <span v-else-if="scope.row.auditStatus == 4" style="color:green;">审核通过且颁证</span>
                        </span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="applyPaperCertificates(scope.row.id)" v-if="scope.row.auditStatus == 1">申请纸质证书</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <el-form :inline="true" :model="from" class="demo-form-inline" label-width="120px" :rules="rules">
                <el-form-item label="姓名" prop="studentDisplayName">
                    <el-input v-model="from.studentDisplayName"></el-input>
                </el-form-item>
                <el-form-item label="姓名拼音" prop="studentPinYin">
                    <el-input v-model="from.studentPinYin"></el-input>
                </el-form-item>
                <el-form-item label="证件类型" prop="idType">
                    <el-select v-model="from.idType" placeholder="请选择">
                        <el-option label="身份证" value="身份证"></el-option>
                        <el-option label="其它" value="其它"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证件号码" prop="idCard">
                     <el-input v-model="from.idCard"></el-input>
                </el-form-item>
                <el-form-item label="证书名称" prop="certificateName">
                    <el-input v-model="from.certificateName"></el-input>
                </el-form-item>
                <el-form-item label="证书编号" prop="certificateNumber">
                    <el-input v-model="from.certificateNumber"></el-input>
                </el-form-item>
                <el-form-item label="证书类型" prop="certificateType">
                    <el-select v-model="from.certificateType" placeholder="请选择">
                        <el-option label="物流管理职业技能等级证书" value="物流管理职业技能等级证书"></el-option>
                        <el-option label="供应链运营职业技能等级证书" value="供应链运营职业技能等级证书"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书等级" prop="certificateLevel">
                    <el-select v-model="from.certificateLevel" placeholder="请选择">
                        <el-option label="初级" value="初级"></el-option>
                        <el-option label="中级" value="中级"></el-option>
                        <el-option label="高级" value="高级"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书批次">
                    <el-select v-model="from.certificateBatchId" placeholder="请选择" :disabled="batchId!=''">
                        <el-option v-for="item in batchList" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书签发日期" prop="certificateIssueDate">
                    <el-date-picker
                        v-model="from.certificateIssueDate"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="考核点" prop="unitName">
                    <el-input v-model="from.unitName" style="width:500px;"></el-input>
                </el-form-item>
                <!-- <el-form-item label="证件头像">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="from.studentUrl" v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 导入考生成绩 -->
        <el-dialog title="Excel批量导入证书信息" :close-on-click-modal="false" :visible.sync="ImportDialogVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="top-tip-con">
                    <div class="clearfix">
                        <el-form :inline="true" size="small" :rules="importRule">
                            <el-form-item label="请选择证书批次" prop="inportcertificateBatchId">
                                <el-select v-model="inportcertificateBatchId" clearable placeholder="请选择证书批次" :disabled="batchId!=''">
                                    <el-option v-for="item in batchList" :key="item.id" :label="item.batchName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="clearfix">
                        <span class="fl">操作提示：</span>
                        <div class="fl tip-article-con">
                            为了方便您的工作，我们已经准备好了《IFPSM证书信息导入模板》的标准模版，请您先下载考生证书导入标准模版，填写后选择填写好的模版导入数据即可，
                            <span class="mark-tip"> 为了能够准确的导入数据，请务必按照标准模版的要求进行填写。 </span>
                        </div>
                    </div>
                    <div class="download-model-con">
                        <a :href="wordUrl" class="el-link">
                            <el-button type="primary" class="download-model-btn">下载IFPSM证书信息导入模板</el-button>
                        </a>
                    </div>
                </div>
                <div class="import-table-con">
                    <p><i class="kz-icon-tishi"></i> 请选择要导入的考生证书信息表格</p>
                    <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList" :auto-upload="false" :on-success="onSuccess" accept="xls" :limit="1" style="display: inline-block; text-align: center; margin-top: 15px">
                        <el-button slot="trigger" type="primary">选择导入文件</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <!-- <el-button type="primary" class="select-impoort-file">选择导入文件</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ImportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="importFile">确定导入</el-button>
            </span>
        </el-dialog>
        <!-- 进度条 -->
        <el-dialog title="数据导入中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 数据导入结果 -->
        <el-dialog title="数据导入结果" :visible.sync="dataResultVisible" width="740px" class="import-stu-info-dialog" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <p><i class="kz-icon-tishi"></i> 您本次共导入{{ count }}条数据，导入结果如下</p>
                    <div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入成功：{{ successNum }}条</span>
                            <a v-if="successNum > 0" :href="successUploadFileUrl">
                                <el-button type="primary" class="fr">下载导入成功记录</el-button>
                            </a>
                        </div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入失败：{{ failNum }}条</span>
                            <a v-if="failNum > 0" :href="failUploadFileUrl">
                                <el-button type="primary" class="fr download-model-btn">下载导入失败记录</el-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dataResultVisible = false">取 消</el-button>
                <el-button type="primary" @click="dataResultVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 批量删除 -->
        <el-dialog :before-close="cancel" title="批量删除" :visible.sync="DeleteAllDialogVisible" width="30%" top="3%" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="120px" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间"> </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间"> </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDeleteAll">取 消</el-button>
                <el-button type="primary" @click="deleteAll()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 考生头像上传 -->
        <el-dialog
            title="考生头像上传"
            :append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="touXiangDialog"
            :show-close="false"
            class="change-dialog-head-wrapper"
            width="50%"
            >
            <div style="position: relative;line-height: 36px">
                <p style="font-size:20px;">注意事项:</p>
                <p style="color:red;font-size:20px;margin-left:50px;">
                1、照片的命名规则为身份证号.图片格式，如 341222200109179410.jpg
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <stuActivtyUpload
                style="margin-right: 10px;"
                :url="urlAliyunOSS"
                :ispartner="0"
                :files="files"
                @done="onAllFilesUpload"
                ></stuActivtyUpload>
                <el-button type="primary" @click="touXiangDialog = false"
                >关 闭</el-button
                >
            </div>
            </el-dialog>
            <el-dialog
            title="未匹配名单"
            :append-to-body="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="TisiDialog"
            :show-close="false"
            class="change-dialog-head-wrapper"
            width="50%"
            >
            <div
                style="position: relative;line-height: 36px;height: 500px;overflow: scroll;"
            >
                <p
                style="color:red;font-size:20px;margin-left:50px;"
                v-for="(item, index) in tisiList"
                :key="index"
                >
                {{ index + 1 }}、{{ item }}
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TisiDialog = false">关 闭</el-button>
            </div>
            </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
import stuActivtyUpload from "components/stuActivtyUpload.vue";
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            studentDisplayName: "",
            idCard: "",
            certificateNumber: "",
            certificateType: "",
            certificateBatchId: "",
            searchAuditStatus:"",
            list: [],
            from: {
                id: "",
                studentDisplayName: "",
                unitName: "",
                idType: "",
                idCard: "",
                studentPinYin: "",
                studentUrl: "",
                certificateNumber: "",
                certificateName:"",
                certificateType: "",
                certificateBatchId: "",
                certificateLevel:"",
                certificateIssueDate:""

            },
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            titleFormVisible: "",
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            // uploadUrl: "/api/XOrg/ItcCertificateMag/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: "",
            batchList: [],
            searCertGradeList: [],
            // 导入结果
            inportcertificateBatchId:"",
            dataResultVisible: false,
            wordUrl: "/public/docs/IFPSM证书信息导入模板.xlsx",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            ids: [],
            importRule: {
                inportcertificateBatchId: [
                    { required: true, message: '请选择证书批次', trigger: 'blur' }
                ]
            },
            // 头像上传
            touXiangDialog: false,
            TisiDialog: false,
            tisiList: [],
            // 获取row的key值
            getRowKeys(row) {
                return row.id;
            },
            batchName:"",
            rules:{
                studentDisplayName:[
                    { required: true, message: '请输入姓名', trigger: 'blur' }
                ],
                studentPinYin:[
                    { required: true, message: '请输入姓名拼音', trigger: 'blur' }
                ],
                idType:[
                    { required: true, message: '请输入证件类型', trigger: 'blur' }
                ],
                idCard:[
                    { required: true, message: '请输入证件号码', trigger: 'blur' }
                ],
                certificateName:[
                    { required: true, message: '请输入证件名称', trigger: 'blur' }
                ],
                certificateNumber:[
                    { required: true, message: '请输入证件编号', trigger: 'blur' }
                ],
                certificateType:[
                    { required: true, message: '请输入证书类型', trigger: 'blur' }
                ],
                certificateLevel:[
                    { required: true, message: '请输入证书等级', trigger: 'blur' }
                ],
                // certificateIssueDate:[
                //     { required: true, message: '请输入证书签发日期', trigger: 'blur' }
                // ],
                unitName:[
                    { required: true, message: '请输入考核点', trigger: 'blur' }
                ]
            }
        };
    },
    components: {
        imageUpload,
        stuActivtyUpload
    },
    props:{
        batchId: {
            type: String,
            default: ""
        }
    },
    computed: {
        uploadUrl(){
            return decodeURI("/api/XOrg/ItcCertificateMag/uploadExcelPro?batchId=" + this.inportcertificateBatchId);
        },
        failUploadFileUrl() {
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=2");
        },
        successUploadFileUrl() {
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=1");
        },
        exportExam: function() {
            return (
                "/api/XOrg/ItcCertificateMag/exportItcExcel?studentDisplayName=" +
                this.studentDisplayName +
                "&idCard=" +
                this.idCard +
                "&certificateNumber=" +
                this.certificateNumber +
                "&certificateType=" +
                this.certificateType +
                "&certificateBatchId=" +
                this.certificateBatchId
            );
        }
    },
    created() {
        this.inportcertificateBatchId = this.batchId;
        this.from.certificateBatchId= this.batchId;
        this.certificateBatchId = this.batchId;
        this.getItcCertificateList();
        this.getItcBatchList();
    },
    watch: {
    },
    methods: {
        handleSelectionChange(val) {
            var that = this;
            this.ids = [];
            val.forEach(element => {
                that.ids.push(element.id);
            });
        },
        //删除
        deleteAll() {
            var that = this;
            this.$confirm("此操作将删除所选证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ItcCertificateMag/deleteCertificates", {
                        ids: this.ids,
                        certificateBatchId: this.batchId
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getItcCertificateList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        // deleteAll() {
        //     var that = this;
        //     this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        //         confirmButtonText: "确定",
        //         cancelButtonText: "取消",
        //         type: "warning",
        //     }).then(() => {
        //         that.$http
        //             .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
        //                 startTime: this.deleteStartTime,
        //                 endTime: this.deleteEndTime,
        //             })
        //             .then(function (rst) {
        //                 if (rst.code > 0) {
        //                     that.$message.success(rst.msg);
        //                     that.DeleteAllDialogVisible = false;
        //                     that.getItcCertificateList();
        //                 } else {
        //                     that.$message.warning(rst.msg);
        //                 }
        //             });
        //     });
        // },
        // 取消进度条
        cancelImport() {
            var that = this;
            that.$http
                .post("/api/XOrg/ImportTask/cancelImport", {
                    id: that.taskId,
                })
                .then(function () {
                    that.percentageVisible = false;
                    clearInterval(that.timer);
                });
        },
        cancelDeleteAll() {
            this.DeleteAllDialogVisible = false;
            this.deleteStartTime = "";
            this.deleteEndTime = "";
        },
        getItcBatchList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatch/getItcBatchList", {
                    type: 0,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.batchList = rst.batchList;
                        let name = "";
                        rst.batchList.forEach(ele =>{
                            if(ele.id == that.batchId){
                                name = ele.batchName;
                            }
                        });
                        that.batchName = name;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.id = "";
            this.from.studentDisplayName = "";
            this.from.unitName = "";
            this.from.idType = "";
            this.from.idCard = "";
            this.from.studentPinYin = "";
            this.from.studentUrl = "";
            this.from.certificateNumber = "";
            this.from.certificateName = "";
            this.from.certificateType = "";
            this.from.certificateBatchId = "";
            this.from.certificateLevel = "";
            this.from.certificateIssueDate = "";
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            var that = this;
            if (res.code > 0) {
                this.ImportDialogVisible = false;
                this.percentageVisible = true;
                this.taskId = res.taskId;
                this.timer = setInterval(function () {
                    that.$http
                        .post("/api/XOrg/ImportTask/getImportProgress", {
                            id: res.taskId,
                        })
                        .then(function (rst) {
                            if (rst.code > 0) {
                                that.percentage = rst.info.progressBar;
                                if (that.percentage == 100) {
                                    clearInterval(that.timer);
                                    that.failNum = rst.info.failNumber;
                                    that.successNum = rst.info.successNumber;
                                    that.count = rst.info.importCount;
                                    that.dataResultVisible = true;
                                    that.percentageVisible = false;
                                    that.percentage = 0;
                                    that.page = 1;
                                    that.cancel();
                                    that.getItcCertificateList();
                                }
                            } else {
                                that.$message.warning(rst.msg);
                            }
                        });
                }, 2000);
            } else {
                this.$message.warning(res.msg);
            }
        },
        //导入题库
        importFile() {
            this.$refs.upload.submit();
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            // this.inportcertificateBatchId = "";
            this.inportcertificateBatchId = this.batchId;
            this.fileList = [];
        },
        addInfo() {
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            debugger;
            this.$http
                .post("/api/XOrg/ItcCertificateMag/addOrEditItcCertificate", {
                    id: this.from.id,
                    studentDisplayName: this.from.studentDisplayName,
                    unitName: this.from.unitName,
                    idType: this.from.idType,
                    idCard: this.from.idCard,
                    studentPinYin: this.from.studentPinYin,
                    studentUrl: this.from.studentUrl,
                    certificateNumber: this.from.certificateNumber,
                    certificateName: this.from.certificateName,
                    certificateType: this.from.certificateType,
                    certificateBatchId: this.from.certificateBatchId,
                    certificateLevel: this.from.certificateLevel,
                    certificateIssueDate: this.from.certificateIssueDate
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getItcCertificateList();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.from.id = row.id;
            this.from.studentDisplayName = row.studentDisplayName;
            this.from.unitName = row.unitName;
            this.from.idType = row.idType;
            this.from.idCard = row.idCard;
            this.from.studentPinYin = row.studentPinYin;
            this.from.studentUrl = row.studentUrl;
            this.from.certificateNumber = row.certificateNumber;
            this.from.certificateName = row.certificateName;
            this.from.certificateType = row.certificateType;
            this.from.certificateBatchId = row.certificateBatchId;
            this.from.certificateLevel = row.certificateLevel;
            this.from.certificateIssueDate = row.certificateIssueDate;
            this.titleFormVisible = "编辑";
            this.dialogFormVisible = true;
        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ItcCertificateMag/deleteCertificates", {
                        ids: id,
                        certificateBatchId: this.batchId
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getItcCertificateList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getItcCertificateList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateMag/getItcCertificateList", {
                    studentDisplayName: this.studentDisplayName,
                    idCard:this.idCard,
                    certificateNumber:this.certificateNumber,
                    certificateType:this.certificateType,
                    certificateBatchId:this.certificateBatchId,
                    auditStatus:this.searchAuditStatus,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getItcCertificateList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getItcCertificateList();
        },
        //上传头像弹窗
        openTXtDialog() {
            this.touXiangDialog = true;
        },
        //学生头像上传
        onAllFilesUpload(file) {
            this.$http
            .post("/api/XOrg/ItcCertificateMag/saveCertificateFile", {
                fileList: JSON.stringify(file),
            })
            .then((res) => {
                if (res.code > 0) {
                    if (res.list.length == 0) {
                        this.$message.success(res.msg);
                        this.touXiangDialog = false;
                    } else {
                        this.TisiDialog = true;
                        this.tisiList = res.list;
                    }
                    this.getItcCertificateList();
                } else {
                    this.$message.warning(res.msg);
                }
            });
        },
        fanhui(){
            this.$router.push({
                name: "itcBatch"
            });
        },
        applyPaperCertificates(id){
            var that = this;
            this.$confirm("此操作将申请纸质证书, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/ItcCertificateMag/applyPaperCertificates", {
                        ids: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getItcCertificateList();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        }
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
    .export-button-a{
        padding: 9px 15px;
        background-color: #409EFF;
        font-size: 12px;
        border-radius: 3px;
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
